import { render, staticRenderFns } from "./MultipleColumns.vue?vue&type=template&id=42c188e2&scoped=true&"
import script from "./MultipleColumns.vue?vue&type=script&lang=js&"
export * from "./MultipleColumns.vue?vue&type=script&lang=js&"
import style0 from "./MultipleColumns.vue?vue&type=style&index=0&id=42c188e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c188e2",
  null
  
)

export default component.exports